import { useEffect, useState } from "react";
import { Button, Card, Col } from "react-bootstrap";

import { getVersionInfo } from "../../api";
import { LicenceDetailedDto } from "../../types/dto";
import { formatLocaleDateString, isTech } from "../../utils";
import {
	BlockInput,
	OfferingAvatarAndText,
	ReadonlyTableRowSetting,
	ReadonlyValueTable,
	SimpleFeaturePill,
} from "..";

export const LicenceCard = (licence: LicenceDetailedDto) => {
	const [downloadUri, setDownloadUri] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [licenceData, setLicenceData] = useState(licence);

	const licTableSetting: ReadonlyTableRowSetting<LicenceDetailedDto>[] = [
		{
			label: "Website",
			accessor: ({ product }) => (
				<a href={product?.websiteLinkUrl}>{product?.websiteLinkUrl}</a>
			),
			isVisible: ({ product }) => !!product?.websiteLinkUrl,
		},
		{
			label: "Version",
			accessor: ({ version }) => version,
		},
		{
			label: "Status",
			accessor: ({ state }) => state,
			isVisible: ({ isOrgEnabled }) => !isOrgEnabled,
		},
		{
			label: "Active Machine",
			accessor: ({ activeMachine }) => activeMachine,
			isVisible: ({ isOrgEnabled }) => !isOrgEnabled,
		},
		{
			label: "Last Used",
			accessor: ({ lastUsedUtc }) =>
				formatLocaleDateString(lastUsedUtc, false),
		},
		{
			label: "Expiry Date",
			accessor: ({ finalExpirationUtc }) =>
				formatLocaleDateString(finalExpirationUtc, false),
		},
		{
			label: "Features",
			accessor: ({ features }) =>
				features?.map((feat) => <SimpleFeaturePill feature={feat} />),
			isVisible: ({ isOrgEnabled }) => !isOrgEnabled,
		},
	];

	const { subscriberOrg, product } = licence;

	useEffect(() => {
		getVersionInfo({ productId: product?.id }).then((prod) => {
			setDownloadUri(prod.downloadUri);
			setIsLoading(false);
			setLicenceData((lic) => ({ ...lic, version: prod.latestVersion }));
		});
	}, []);

	return (
		<Col
			sm={12}
			md={6}
			xl={4}
			xxl={3}
			className="mb-3"
			data-testid="test-licenceCard"
		>
			<Card>
				<BlockInput blocking={isLoading} />
				<Card.Header className="p-3">
					<OfferingAvatarAndText
						text={`${subscriberOrg?.name}: ${product?.name}`}
						offering={product}
						size={33}
					/>
				</Card.Header>
				<Card.Body>
					<ReadonlyValueTable
						data={licenceData}
						settings={licTableSetting}
						className="mb-2"
					/>
				</Card.Body>
				<Button
					href={`${
						isTech
							? import.meta.env.VITE_API_URL_TECH
							: import.meta.env.VITE_API_URL
					}/Products/Download?ProductId=${product?.id}`}
					disabled={!downloadUri}
				>
					{downloadUri || isLoading
						? "Download Installer"
						: "No Installer Registered"}
				</Button>
			</Card>
		</Col>
	);
};
